<template>
  <div>
    <div class="icoPlace"></div>
    <div class="slimButton" :class="{ error }" @click="open">
      Place ({{ value.length }})
    </div>

    <Modal
      ref="modalRef"
      title="Campaigns - Place"
      width="850px"
      modalClass="placeBg"
    >
      <div class="timePlaceModal" :class="{ disabled: readOnly }">
        <div class="timePlaceModal__bg"></div>

        <div class="timePlaceModal__places">
          <div
            class="timePlaceModal__places__place"
            v-for="spot in locations"
            :key="spot.id"
          >
            <label class="container">
              <input
                type="checkbox"
                :id="spot.id"
                :value="spot.id"
                v-model="localValue"
                :disabled="readOnly"
              />
              <span class="checkmark"></span>
              {{ spot.name }}
            </label>
          </div>
        </div>

        <div class="timePlaceModal__selectedNumber place">
          Selected <span class="number">{{ localValue.length }}</span>
          <span v-if="localValue.length > 1 || localValue.length == 0"
            >places</span
          ><span v-else>place</span>
        </div>

        <div class="timePlaceModal__confirm" @click="confirm">Confirm</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

export default {
  name: "PlaceButton",
  mixins: [ModalJs],
  components: {
    Modal,
  },
  props: {
    readOnly: Boolean,
    error: Boolean,
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value || [],
    };
  },
  computed: {
    ...mapGetters({
      locations: "gameLocations",
    }),
  },
  watch: {
    value(value) {
      if (value !== this.localValue) {
        this.localValue = value || [];
      }
    },
  },
  methods: {
    confirm() {
      this.$emit("input", this.localValue);
      this.closeModal();
    },
    open() {
      this.localValue = this.value;
      this.openModal();
    },
  },
};
</script>
